import Icon from '../components/Icon';

const Weather18Colored = Icon(
  'weather-18-colored',
  <>
    <path
      fill="#A180D3"
      d="M15.327 15.357a.75.75 0 0 0-1.32-.713l-1.667 3.083a.75.75 0 0 0 1.32.713zM17.327 18.357a.75.75 0 0 0-1.32-.713l-1.667 3.083a.75.75 0 0 0 1.32.713zM9 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.722 7.84a6.5 6.5 0 0 1 12.133-2.528A4.85 4.85 0 1 1 17.183 15H5.6a3.633 3.633 0 0 1-.879-7.16"
      clipRule="evenodd"
    />
  </>
);

export default Weather18Colored;
